import { ApiClientInterface } from './clients';
import { AccountTopupConfirmation, InvestmentPackage, Money, UuidResult } from './models';

export class AccountTopupConfirmationManager {
  constructor(private readonly apiClient: ApiClientInterface) {}

  public create(money: Money, enableCapitalProtection: boolean): Promise<UuidResult> {
    return this.apiClient.post('/', { money, enableCapitalProtection });
  }

  public get(confirmationUuid: string): Promise<AccountTopupConfirmation> {
    return this.apiClient.get(`/${confirmationUuid}`);
  }

  public sendCode(confirmationUuid: string): Promise<void> {
    return this.apiClient.post('/send-code', { confirmationUuid });
  }

  public confirmCode(smsCode: string, confirmationUuid: string): Promise<InvestmentPackage> {
    return this.apiClient.post('/confirm-code', { smsCode, confirmationUuid });
  }
}
